import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { LatestEventsQuery } from '@custom/schema';

export const useLatestEventsQuery = () =>
  useStaticQuery<LatestEventsQuery>(graphql(LatestEventsQuery));
